enum VERIFICATION_STATUS {
    PENDING = 'pending',
    APPROVED = 'approved',
    EXPIRED = 'expired',
}

enum SEND_METHOD {
    SMS = 'sms',
    CALL = 'call',
    EMAIL = 'email',
}
export { VERIFICATION_STATUS, SEND_METHOD };
